import { render } from "./GeneralContactForm.vue?vue&type=template&id=3c0082c9&scoped=true"
import script from "./GeneralContactForm.vue?vue&type=script&lang=js"
export * from "./GeneralContactForm.vue?vue&type=script&lang=js"

import "./GeneralContactForm.vue?vue&type=style&index=0&id=3c0082c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c0082c9"]])

export default __exports__